module.exports = __webpack_public_path__ + "static/media/PinStrip.24c5ada2.png";